import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FilterNavigation } from 'ish-core/models/filter-navigation/filter-navigation.model';
import { Filter } from 'ish-core/models/filter/filter.model';
import { URLFormParams } from 'ish-core/utils/url-form-params';
import { FilterDropdownComponent } from 'ish-shared/components/filter/filter-dropdown/filter-dropdown.component';

@Component({
  selector: 'ish-filter-navigation-horizontal',
  templateUrl: './filter-navigation-horizontal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FilterDropdownComponent, TranslateModule],
})
export class FilterNavigationHorizontalComponent {
  readonly filterNavigation = input.required<FilterNavigation>();
  readonly applyFilter = output<{
    searchParameter: URLFormParams;
  }>();

  trackByFn(_: number, item: Filter) {
    return item.id;
  }
}
